import React from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { SWIPER_STYLE } from '@common/styles';

import { ZSymbolIcon } from '../assets/ZSymbolIcon';

export interface ShortClipComponentProps {
  children: React.ReactNode;
}

const ShortClipComponent = React.forwardRef<HTMLDivElement, ShortClipComponentProps>(
  ({ children }, ref): JSX.Element => {
    return <Wrapper ref={ref}>{children}</Wrapper>;
  },
);

export interface ShortClipProps
  extends React.ForwardRefExoticComponent<ShortClipComponentProps & React.RefAttributes<HTMLDivElement>>,
    ShortClipCompoundProps {}

interface ShortClipCompoundProps {
  Header: typeof Header;
  Title: typeof Title;
  ClipIcon: typeof ClipIcon;
  Subtitle: typeof Subtitle;
  Carousel: typeof Carousel;
}

const Wrapper = styled.div`
  ${SWIPER_STYLE};
  padding: 32px 0;
`;

const Header = styled.div`
  margin: 0 0 15px 0;
`;

const Title = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 3px;
  height: 20px;
  color: ${vars.v3Color.gray900};
`;

const ClipIcon = styled(ZSymbolIcon)`
  margin: 1px 0 0 0;
`;

const Subtitle = styled.p`
  margin: 4px 0 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 17px;
  color: ${vars.v3Color.gray500};
`;

const Carousel = styled.div`
  .single {
    width: 100% !important;
  }
  .swiper {
    padding: 0 16px;
  }
`;

export const ShortClip = {
  ...ShortClipComponent,
  Header,
  Title,
  ClipIcon,
  Subtitle,
  Carousel,
} as ShortClipProps;
